import { useState, useEffect } from "react";

import './Update.css';

import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "../../interface/Data";

interface DataUpdate {
    id             : number;
    id_client      : number;
    type           : number;
    version_       : number;
    date           : string;
    comporate_name : string;
    file           : string;
    text           : string;
}

export default function Page_Update() {

    const [ listData, setListData ] = useState<{ [key: string]: DataUpdate }>(GetDataPage("updates") || {});

    useEffect(() => {
        RegisterDataPage("updates", setListData);
        return () => { UnRegisterDataPage("updates", setListData); };
    }, []);
    
    return (
        <div className="page_data_list Page_Update">
            <table cellPadding={ 0 } cellSpacing={ 0 }>
                <thead>
                    <tr>
                        <th align="center" style={ { width: "20px" } }>#</th>
                        <th>Company</th>
                        <th style={ { width: "62px" } }>Type</th>
                        <th style={ { width: "40px" } }>Version</th>
                        <th style={ { width: "138px" } }>Last update</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        
                        Object.keys(listData).length > 0 ?
                            Object.keys(listData).map((elem, index) => {
                                const showInf = listData[elem];

                                return(
                                    <tr key={ elem }>
                                        <td align="center">{ index + 1 }</td>
                                        <td>{ showInf.comporate_name }</td>
                                        <td>{ showInf.type === 1 ? "Site raiz" : "Project" }</td>
                                        <td>{ showInf.version_ }</td>
                                        <td>{ showInf.date }</td>
                                    </tr>
                                );
                            })
                        :
                        <tr>
                            <td colSpan={ 6 } align="center">No data found</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}